export default __webpack_public_path__ + "img/add.a9e12fbf.svg";